import { Inquiry } from '../components/Inquiry';
import { useInquiryService } from '../services/useInquiryService';

export const ConcatInquiryContainer: React.FC<React.PropsWithChildren<unknown>> = () => {
  const service = useInquiryService();
  return (
    <Inquiry
      disabled={service.disabled}
      showDivider={service.showDivider}
      inquiry_path_message={service.inquiry_path_message}
      isInApp={service.isZigzagApp}
      isZigzin={service.isZigzin}
      isNotParentShop={service.isNotParentShop}
      moveToShippingCSChat={service.moveToShippingCSChat}
      moveToInquiryHistory={service.moveToInquiryHistory}
      addQuestion={service.addQuestion}
    />
  );
};
